import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

export const SubLabel = styled.div`
  font-size: 0.875rem;
  line-height: 1.25rem;
  position: absolute;
  left: 0;
  color: ${color.GREY};

  // keep "top" tight because it's the InputCell that's
  // making room for this and if it's too far down, it'll
  // run into the label of any field under it. If you adjust
  // this, make sure to adjust the bottom spacing in InputCell.
  top: 4.0625rem;
`

export const ErrorMessage = styled(SubLabel)`
  color: ${color.WATERMELON};
  top: auto;
`

export const RequirementList = styled.ul`
  font-size: 0.875rem;
  margin: 0.3125rem 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
`

// the theme here is provided locally, not from the main
// theme provider, so we can use them just fine.
export const Requirement = styled.li`
  list-style: none;
  flex-basis: 50%;
  color: ${p => p.theme.color};
  transition: color 0.2s;
  margin-top: 0.625rem;
  padding-left: 1.875rem;
  position: relative;
  line-height: normal;

  &:before {
    content: '';
    position: absolute;
    top: -0.125rem;
    left: 0.3125rem;
    height: 0.9375rem;
    width: 0.9375rem;
    border-radius: 100%;
    background: ${p => p.theme.bulletColor};
    transition: background-color 0.2s;
  }
`
